module.exports = __webpack_public_path__ + "static/media/provider_netent.919269ec.jpg";